import React from 'react'
import SubmitButton from '../form_components/SubmitButton'
import { useAppSelector } from '../../utils/storeHooks'

const ContactPage = () => {

    const {lang} = useAppSelector(store => store.display)

    const pageContent = {
        en: {
            title: 'Get in touch',
            name: 'Name: ',
            email: 'Email address:',
            about: 'Subject:',
            message: 'Message: ',
            submit: 'Send message'
        },
        ma: {
            title: 'Whakapā mai',
            name: 'Tō ingoa: ',
            email: 'Tō īmēra:',
            about: 'Take:',
            message: 'Karere:',
            submit: 'Tuku karere'
        }
    }


    const smWidth = 'w-full'
    const fieldStyle = 'relative md:w-70% md:flex mb-2';
    const textboxStyle = `${smWidth} bg-kaho-0 md:w-[50%]`;
    const labelStyle = 'block max-md:pb-1 md:w-20 md:mr-2 md:text-right md:pt-2';

    return (
        <div className='mx-auto bodyHeight pt-0 pb-8 px-4 max-w-200'>
            <form className='flex-whenu' onSubmit={(e) => {e.preventDefault()}}>
                <h1 className={`${smWidth} max-md:pt-4 md:w-[calc(80%-176px)] mb-2`}>{pageContent[lang].title}</h1>
                <div className={`${smWidth} flex flex-col flex-none md:w-[80%] pb-2`}>
                    <div className={fieldStyle}>
                        <label className={labelStyle} htmlFor="kIngoa" >{pageContent[lang].name}</label>
                        <input id="kIngoa" className={textboxStyle} placeholder={pageContent[lang].name} type='text' />
                    </div>
                    <div className={fieldStyle}>
                        <label className={labelStyle} htmlFor="kImera" >{pageContent[lang].email}</label>
                        <input id="kImera" className={textboxStyle} placeholder={pageContent[lang].email} type='text' />
                    </div>
                    <div className={fieldStyle}>
                        <label className={labelStyle} htmlFor="kTake" >{pageContent[lang].about}</label>
                        <input id="kTake" className={textboxStyle + ' grow'} placeholder={pageContent[lang].about} type='text' />
                    </div>
                    <div className={fieldStyle}>
                        <label className={labelStyle} htmlFor="kKarere" >{pageContent[lang].message}</label>
                        <textarea id="kKarere" className='bg-kaho-0 grow max-md:w-full' placeholder={pageContent[lang].message}/>
                    </div>
                </div>
                <div className='w-full flex-aho-reverse md:w-[80%]'>
                    <SubmitButton text={pageContent[lang].submit}/>
                </div>
            </form>
        </div>
    )
}

export default ContactPage
